import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService, BaseConfigService } from '@base-shared/services';
import { isEmpty } from 'lodash';


@Injectable()
export class AnonymousGuard implements CanActivate {

  public client: any;

  constructor(
    private router: Router,
    private auth: AuthService,
    private appClient: BaseConfigService,
  ) {
    this.client = this.appClient.client;
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (this.auth.token && !isEmpty(this.auth.user)){

      switch (this.client.type) {
        case "registration":
          this.router.navigate(['projects']);
          break;
        default:
          this.router.navigate(['eyrus/projects']);
          break;
       }
      
    }

    return true;
  }

  /**
   * Trigger not authorized flow
   */
  notAuthorized() {
    this.router.navigate(['/auth/login']);
    return false;
  }
}